if (!customElements.get('product-card-siblings')) {
  class ProductCardSiblings extends HTMLElement {
    constructor() {
      super();

      this.siblingItems = this.querySelectorAll('.product-siblings__item');
      this.productCard = this.closest('product-card');
      this.productCardTitle = this.productCard.querySelector('.product-card-title');
      this.productCardPrice = this.productCard.querySelector('.price .amount');
      this.productCardLink = this.productCard.querySelector('.product-featured-image-link');
      this.productCardQuickView = this.productCard.querySelector('quick-view');
      this.productCardPrimaryImg = this.productCard.querySelector('.product-primary-image');
      this.productCardSecondaryImg = this.productCard.querySelector('.product-secondary-image');
      this.siblingItems.forEach(siblingItem => siblingItem.addEventListener('click', this.handleSiblingClick.bind(this)));
    }

    handleSiblingClick(e) {
      if (e.currentTarget.className.includes('active')) {
        return;
      }

      this.querySelector('.product-siblings__item.active').classList.remove('active');
      const newSiblingEle = e.currentTarget;
      newSiblingEle.classList.add('active');

      this.productCardTitle.textContent = newSiblingEle.dataset.title;
      this.productCardPrice.textContent = newSiblingEle.dataset.price;
      this.productCardLink.href = newSiblingEle.dataset.handle;
      this.productCardTitle.href = newSiblingEle.dataset.handle;
      this.productCardQuickView.dataset.productHandle = newSiblingEle.dataset.handle;
      this.productCardPrimaryImg.src = newSiblingEle.dataset.primaryImg;
      this.productCardPrimaryImg.srcset = '';
      this.productCardSecondaryImg.src = newSiblingEle.dataset.secondaryImg;
      this.productCardSecondaryImg.srcset = '';
    }
  }

  customElements.define('product-card-siblings', ProductCardSiblings);
}